// import React, { useState } from "react";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import SuccessModal from "../../utilities/SuccessModal";
// import { config } from "../../App";
// import "./ResetPassword.scss";

// const PasswordInput = ({
//   label,
//   value,
//   onChange,
//   isVisible,
//   toggleVisibility,
// }) => {
//   return (
//     <div className="password-input-wrapper form-group mb-4">
//       <input
//         type={isVisible ? "text" : "password"}
//         className="form-control p-4 font-md dark-grey-text"
//         placeholder={label}
//         value={value}
//         onChange={(event) => onChange(event.target.value)}
//       />
//       <span className="password-toggle-icon" onClick={toggleVisibility}>
//         {isVisible ? (
//           <img
//             className="icon-24"
//             src="./images/eye-fill.svg"
//             alt="eye-fill-icon"
//           />
//         ) : (
//           <img
//             className="icon-24"
//             src="./images/eye-slash.svg"
//             alt="eye-slash-fill-icon"
//           />
//         )}
//       </span>
//     </div>
//   );
// };

// const ResetPassword = () => {
//   const token = sessionStorage.getItem("token");
//   const userId = sessionStorage.getItem("userId");
//   const [username, setUsername] = useState(sessionStorage.getItem("username"));
//   const [modalIsOpen, setIsOpen] = React.useState(false);
//   const [oldPassword, setOldPassword] = useState("");
//   const [newPassword, setNewPassword] = useState("");
//   const [errors, setErrors] = useState({});
//   const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
//   const [newPasswordVisible, setNewPasswordVisible] = useState(false);
//   const [confirmPassword, setConfirmPassword] = useState("");

//   const [msg, setRespMsg] = useState("");
//   const navigate = useNavigate();

//   const openFilterModal = () => {
//     setIsOpen(true);
//   };
//   const closeFilterModal = () => {
//     setIsOpen(false);
//     navigate(`/${config.baseUrl}/login`);
//   };

//   const togglePasswordVisibility = (setter) => {
//     setter((prev) => !prev);
//   };

//   const handleSubmit = async (event) => {
//     event.preventDefault();
//     const formData = {
//       employeeId: userId,
//       oldPassword: oldPassword,
//       newPassword: newPassword,
//     };
//     if (isSubmitDataValid(formData)) {
//       await handleResetPassword(formData);
//     }
//   };

//   const isSubmitDataValid = (formData) => {
//     const newErrors = {};

//     if (!formData.oldPass || formData.oldPass.trim() === "") {
//       newErrors.oldPassword = "Old Password cannot be empty";
//     }

//     if (!formData.newPass || formData.newPass.trim() === "") {
//       newErrors.newPassword = "New Password cannot be empty";
//     }

//     if (formData.newPass !== confirmPassword) {
//       newErrors.confirmPassword = "Password does not match";
//     }

//     if (!newErrors.oldPassword && formData.oldPass.length < 6) {
//       newErrors.oldPassword = "Old Password must be at least 6 characters long";
//     }

//     if (!newErrors.newPassword && formData.newPass.length < 6) {
//       newErrors.newPassword = "New Password must be at least 6 characters long";
//     }


//     setErrors(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const handleResetPassword = async (formData) => {
//     try {
//       const response = await axios.post(
//         `${config.endpoint}/Home/changepassword`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${token}`
//           },
//         }
//       );
//       if (response.data.responseCode === 0 && response.data.data) {
//         openFilterModal();
//       } else {
//         setRespMsg(`${response.data.responseMessage === "Old and new password are same, please chose another password" ?
//           "The old and new passwords are the same. Please choose a different password." :"Wrong Old password."
//         }`);
//       }
//     } catch (error) {}
//   };
//   return (
//     <>
//       <div className="reset-password card">
//         <p className="font-md extraBold mb-5">Change Password</p>
//         {msg && <p className="font-sm regular mb-0 primary-text">{msg}</p>}
//         <div className="form mt-2">
//           <form
//             id="login-form"
//             method="post"
//             name="login-form"
//             onSubmit={handleSubmit}
//           >
//             <div className="form-group mb-5 col-lg-5">
//               <label
//                 htmlFor="userName"
//                 className="mb-2 font-md regular mb-1 mid-dark-text "
//               >
//                 Username
//               </label>
//               <input
//                 type="text"
//                 className="form-control p-4 font-md dark-grey-text"
//                 placeholder="User Name"
//                 name="username"
//                 value={username}
//                 disabled={true}
//               />
//             </div>
//             <div className="form-group mb-5 col-lg-5">
//               <label
//                 htmlFor="userName"
//                 className="mb-2 font-md regular mb-1 mid-dark-text "
//               >
//                 Old Password<sup class="primary-alternate-2-text font-sm bold">*</sup>
//               </label>
//               <PasswordInput
//                 label="Enter Old Password"
//                 value={oldPassword}
//                 onChange={setOldPassword}
//                 isVisible={oldPasswordVisible}
//                 toggleVisibility={() =>
//                   togglePasswordVisibility(setOldPasswordVisible)
//                 }
//               />
//               {errors.oldPassword && (
//                 <p className="error-text font-sm regular">
//                   {errors.oldPassword}
//                 </p>
//               )}
//             </div>
//             <div className="form-group mb-5 col-lg-5">
//               <label
//                 htmlFor="userName"
//                 className="mb-2 font-md regular mb-1 mid-dark-text "
//               >
//                 New Password<sup class="primary-alternate-2-text font-sm bold">*</sup>
//               </label>
//               <PasswordInput
//                 label="Enter New Password"
//                 value={newPassword}
//                 onChange={setNewPassword}
//                 isVisible={newPasswordVisible}
//                 toggleVisibility={() =>
//                   togglePasswordVisibility(setNewPasswordVisible)
//                 }
//               />

//               {errors.newPassword && (
//                 <p className="error-text font-sm regular">
//                   {errors.newPassword}
//                 </p>
//               )}
//             </div>
//             <div className="form-group mb-5 col-lg-5">
//               <label
//                 htmlFor="confirmPassword"
//                 className="mb-2 font-md regular mb-1 mid-dark-text "
//               >
//                 Confirm New Password<sup className="primary-alternate-2-text font-sm bold">*</sup>
//               </label>
//               <PasswordInput
//                 label="Confirm New Password"
//                 value={confirmPassword}
//                 onChange={setConfirmPassword}
//                 isVisible={newPasswordVisible}
//                 toggleVisibility={() =>
//                   togglePasswordVisibility(setNewPasswordVisible)
//                 }
//               />
//               {errors.confirmPassword && (
//                 <p className="error-text font-sm regular">
//                   {errors.confirmPassword}
//                 </p>
//               )}
//             </div>
//             <div className="mt-4">
//               <button
//                 type="submit"
//                 className="btn-primary submit-btn font-md btn btn-animation"
//               >
//                 Change Password
//               </button>
//             </div>
//           </form>
//         </div>
//       </div>
//       <SuccessModal
//         isOpen={modalIsOpen}
//         onClose={closeFilterModal}
//         message="Password change successful!"
//       />
//     </>
//   );
// };
// export default ResetPassword;

import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../utilities/SuccessModal";
import { config } from "../../App";
import "./ResetPassword.scss";
import { useAuth } from "../../_services/authService";

const PasswordInput = ({ label, value, onChange, isVisible, toggleVisibility }) => {
  return (
    <div className="password-input-wrapper form-group mb-4 position-relative">
      <input
        type={isVisible ? "text" : "password"}
        className="form-control p-3 font-md dark-grey-text"
        placeholder={label}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <span
        className="password-toggle-icon position-absolute top-50 end-0 translate-middle-y pe-3"
        onClick={toggleVisibility}
        style={{ cursor: "pointer" }}
        >
        {isVisible ? (
          <img className="icon-24" src="/images/eye-fill.svg" alt="show" />
        ) : (
          <img className="icon-24" src="/images/eye-slash.svg" alt="hide" />
        )}
      </span>
    </div>
  );
};

const ResetPassword = () => {

  const { logout } = useAuth();
  const navigate = useNavigate();
  const token = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("userId");

  const [username] = useState(sessionStorage.getItem("username") || "");

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({});
  const [serverMessage, setServerMessage] = useState("");

  const [oldPasswordVisible, setOldPasswordVisible] = useState(false);
  const [newPasswordVisible, setNewPasswordVisible] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const toggleVisibility = (setter) => () => setter((prev) => !prev);

  const validateForm = () => {
    const newErrors = {};

    if (!oldPassword.trim()) {
      newErrors.oldPassword = "Old password is required";
    } else if (oldPassword.length < 6) {
      newErrors.oldPassword = "Old password must be at least 6 characters";
    }

    if (!newPassword.trim()) {
      newErrors.newPassword = "New password is required";
    } else if (newPassword.length < 8) {
      newErrors.newPassword = "New password must be at least 8 characters";
    } else if (newPassword === oldPassword) {
      newErrors.newPassword = "New password cannot be same as old password";
    }

    if (!confirmPassword.trim()) {
      newErrors.confirmPassword = "Please confirm your new password";
    } else if (confirmPassword !== newPassword) {
      newErrors.confirmPassword = "Passwords do not match";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setServerMessage("");

    if (!validateForm()) return;

    const payload = {
      employeeId: userId,
      oldPassword: oldPassword,
      newPassword: newPassword,
    };

    try {
      const response = await axios.post(
        `${config.endpoint}/Home/changepassword`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const { responseCode, responseMessage, data } = response.data;

      if (response.data.status === true) {
        setModalIsOpen(true);
      } else {
        setServerMessage(response.data.ResponseMessage);
        // if (responseMessage?.toLowerCase().includes("old and new password are same")) {
        // setServerMessage("New password cannot be the same as old password.");
        // } else if (responseMessage?.toLowerCase().includes("wrong") || responseMessage?.includes("invalid")) {
        //   setServerMessage("Incorrect old password.");
        // } else {
        //   setServerMessage(responseMessage || "Failed to change password. Please try again.");
        // }
      }
    } catch (err) {
      const msg = err.response?.data?.responseMessage || "Network error. Please try again later.";
      setServerMessage(msg);
    }
  };

  const closeModalAndRedirect = () => {
    setModalIsOpen(false);
    sessionStorage.clear();
    logout();
    navigate(`/login`);
    // Or navigate to profile/dashboard → navigate(`/${config.baseUrl}/profile`);
  };

  return (
    <>
    <section className="px-4">
      <div className="container-fluid">
        <div className="card border-0 p-4 pb-2">
          <div className="reset-password p-0">
            <h1 class="fs-22 fw-semibold mb-4">Change Password</h1>

            {serverMessage && (
              <p className="font-sm regular mb-3 text-danger">{serverMessage}</p>
            )}

            <form onSubmit={handleSubmit} className="mt-2">
              {/* Username – readonly */}
              <div className="form-group mb-5 col-lg-5">
                <label className="mb-2 font-md mid-dark-text">Username</label>
                <input
                  type="text"
                  className="form-control p-3 font-md dark-grey-text"
                  value={username}
                  disabled
                />
              </div>

              {/* Old Password */}
              <div className="form-group mb-5 col-lg-5">
                <label className="mb-2 font-md mid-dark-text">
                  Old Password <sup className="primary-alternate-2-text font-sm bold">*</sup>
                </label>
                <PasswordInput
                  label="Enter old password"
                  value={oldPassword}
                  onChange={setOldPassword}
                  isVisible={oldPasswordVisible}
                  toggleVisibility={toggleVisibility(setOldPasswordVisible)}
                />
                {errors.oldPassword && (
                  <small className="error-text d-block mt-1">{errors.oldPassword}</small>
                )}
              </div>

              {/* New Password */}
              <div className="form-group mb-5 col-lg-5">
                <label className="mb-2 font-md mid-dark-text">
                  New Password <sup className="primary-alternate-2-text font-sm bold">*</sup>
                </label>
                <PasswordInput
                  label="Enter new password"
                  value={newPassword}
                  onChange={setNewPassword}
                  isVisible={newPasswordVisible}
                  toggleVisibility={toggleVisibility(setNewPasswordVisible)}
                />
                {errors.newPassword && (
                  <small className="error-text d-block mt-1">{errors.newPassword}</small>
                )}
              </div>

              {/* Confirm Password */}
              <div className="form-group mb-5 col-lg-5">
                <label className="mb-2 font-md mid-dark-text">
                  Confirm New Password <sup className="primary-alternate-2-text font-sm bold">*</sup>
                </label>
                <PasswordInput
                  label="Confirm new password"
                  value={confirmPassword}
                  onChange={setConfirmPassword}
                  isVisible={newPasswordVisible}
                  toggleVisibility={toggleVisibility(setNewPasswordVisible)}
                />
                {errors.confirmPassword && (
                  <small className="error-text d-block mt-1">{errors.confirmPassword}</small>
                )}
              </div>

              <button
                type="submit"
                className="btn-primary submit-btn font-md btn btn-animation px-5 mt-5 mb-4"
              >
                Change Password
              </button>
            </form>
          </div>

        </div>
      </div>
    </section>

      <SuccessModal
        isOpen={modalIsOpen}
        onClose={closeModalAndRedirect}
        message="Password changed successfully!"
      />
    </>
  );
};

export default ResetPassword;
